const iframe = document.querySelector<HTMLIFrameElement>('#calendar-iframe')

// Wait for the iframe to load
if (iframe) {
	iframe.addEventListener('load', () => {
		const channel = new MessageChannel()
		channel.port1.onmessage = e => {
			iframe.setAttribute('style', `height: ${e.data + 2}px;`)
		}
		iframe.contentWindow?.postMessage('init', '*', [channel.port2])
	})
}
